import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '@hooks/reduxHooks'
import { WasteTabs } from '@components/tables/WasteTableTabs'
import WasteContainersTable from '@components/tables/WasteContainersTable'
import { resetActiveTab } from '@state/reducers/wasteReducer'
import WasteEntriesTable from '@components/tables/WasteEntriesTable'

export default function RadiopharmacyWaste() {
  const dispatch = useAppDispatch()
  const activeTab = useAppSelector(({ waste }) => waste.activeTab)

  useEffect(() => { 
    return () => {
      dispatch(resetActiveTab())
    }
  }, [])

  return (
    <>
      {activeTab === WasteTabs.Entries && (<WasteEntriesTable />)}
      {activeTab === WasteTabs.Containers && (<WasteContainersTable showTabs />)}
    </>
  )
}
